import { render, staticRenderFns } from "./EModalSelectBimestres.vue?vue&type=template&id=4d8a8146&scoped=true"
import script from "./EModalSelectBimestres.vue?vue&type=script&lang=js"
export * from "./EModalSelectBimestres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8a8146",
  null
  
)

export default component.exports